import React from "react";
import TabsNavigator from "components/TabsNavigator";
import PageShell from "components/bento/PageShell";
import UserList from "./userList";
import RoleList from "scenes/role/RoleList";

const UsersAndRoles = () => {
  const tabItems = [
    { text: "Users", component: <UserList />, slug: "users/list" },
    { text: "Roles", component: <RoleList />, slug: "users/roles" },
  ];

  return (
    <PageShell title="Users & Roles">
      <TabsNavigator tabItems={tabItems} pageSlug="users" />
    </PageShell>
  );
};

export default UsersAndRoles;
